import { Observable } from 'rxjs';

export abstract class ToastService {
  abstract showToast(
    message: string,
    action?: string | null,
    option?: Partial<any>,
  ): Observable<any>;
}
